import anime from 'animejs';

document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll<HTMLElement>('[data-skew]');
	els.forEach((el) => {
		const styles = getComputedStyle(el);
		if (styles.getPropertyValue('display') === 'inline') {
			el.style.display = 'inline-block';
		}

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					observer.unobserve(el);
					anime({
						targets: el,
						rotate: [0, 15],
						duration: 1200,
						delay: 300,
						easing: 'cubicBezier(0.03, 0.86, 0.28, 1.00)',
					});
				}
			},
			{
				threshold: 1,
			},
		);

		observer.observe(el);
	});
});
